export const AVAILABILITY_SECTION_RELEASE_DATE = new Date('2021-12-08');
